import React from 'react'
import { promocodes } from '../../../../utils/pages-meta.json'
import { useParams, Redirect } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import { SEO } from '../../../../components/Seo/seo'
import { NamedRoutes } from '../../../../routes'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { FormLoader } from '../../../../components/Loader/FormLoader'
import Layout from '../../../../components/Dashboard/Layout/Layout'
import { PromocodeProvider } from '../../../../PromocodeContext'
import PromocodeEditContent from '../../../../components/Dashboard/Subscription/PromocodeEditContent'

const SinglePromocodeEdit = () => {
  let { id } = useParams()
  const intl = useIntl()
  return (
    <>
      {!!id && !!parseInt(id) ?
        <>
          <SEO title={intl.formatMessage({ id: 'Promocodes.List.EditPromocode.Title' })}
            pathname={window.location.origin}
            titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
            image={promocodes.image}
            description={intl.formatMessage({ id: 'Promocodes.List.EditPromocode.Title' })}
          />
          <AuthenticatedUserConsumer>
            {({ userDataLoading, userData, handleNotificationCall }) => (
              <>
                {!!userDataLoading && <FormLoader loading={true} />}
                {!!Object.keys(userData).length &&
                  <>
                    {!!userData.is_admin ? <Layout content={
                      <PromocodeProvider promocodeId={id} isEdit handleNotificationCall={handleNotificationCall}>
                        <PromocodeEditContent pageTitle={<FormattedMessage id='Promocodes.List.EditPromocode.Title' />} />
                      </PromocodeProvider>} />
                      :
                      (!userDataLoading && <Redirect to={NamedRoutes.home} />)
                    }
                  </>
                }
              </>
            )}
          </AuthenticatedUserConsumer>
        </>
        :
        <Redirect to={NamedRoutes.subscription.promocodes.list} />
      }
    </>
  )
}

export default SinglePromocodeEdit